import {
  Box,
  Card,
  Grid,
  IconButton,
  ListItem,
  ListItemIcon,
  Paper,
  Typography,
} from "@mui/material";
import Button from "@material-ui/core/Button";
import React, { useState, useContext } from "react";
import { ApptContext, InitialSlotsObj } from "../../../../../store";
import AppointmentFilterPage from "./AppointmentFilter";
import Configurations from "../../../../../config";
import useStyles from "../../../../../css/styles_PE";
import { UpdateAppointmentObject } from "../../../../../actions";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { GetAdminSettingValue, InsertPPLogs } from "../../../../../api";//FB 8024
import AppointmentTypePage from "./AppointmentType";//FB 8024

// Update log
// FB  6192   02/06/2023  DK  Home page for the PE workflows
// FB  7443   09/21/2023  DK  Replace Inoffice with In-office across the portal
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8192   02/01/2024  SK  Sophie - appointment booking under patient portal is different than PE
// FB  8214   02/01/2024  SK  Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE


export default function AppointmentIndex(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(ApptContext);
  const [apptType, setApptType] = useState(state.AppointmentType);
  const [customApptValue, setCustomApptValue] = useState("");//FB 8024
  const [disableForm, setDisableForm] = useState(false);//FB 8192
  const navigate = useNavigate();
  const handleClick = (selected: string) => {
    setApptType(selected);
    state.AppointmentType = selected;
    state.CustomAppointmentType="";//FB 8024
    state.AppointmentFilter = "";
    state.Provider = {
      ID: 0,
      Name: "",
      Facility_n: 0,
      Bio: "",
      JobTitle: ""
    };
    state.Facility = {
      ID: 0,
      Name: "",
      Address: "",
      Phone: "",
      Region: 0,
      GOOGLE_MAPS_LINK: "" //FB 7413

    };
    state.FacilityRegion = {
      ID: 0,
      Name: "",
      State: ""
    }
    state.AppointmentDate = new Date();
    state.Duration = 0;
    state.SlotDetails = InitialSlotsObj;
    state.Appointment_N = 0;

    if (selected == "inoffice") {
      // FB 7443
      InsertPPLogs("Selected In-office", window.location.href, userName, "");
    } else if (selected == "telederm") {
      InsertPPLogs("Selected telederm", window.location.href, userName, "");
    }
  };
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  function getcomponent() {
    switch (apptType) {
      case "inoffice":
        //FB 8024 - Begin
        if (customApptValue == "true" || customApptValue == "True") {
          return <AppointmentTypePage setApptType={setApptType} />;
        }
        else {
          return <AppointmentFilterPage setApptType={setApptType} />;
        }
        break;

      case "telederm":
        if (customApptValue == "true" || customApptValue == "True") {
          return <AppointmentTypePage setApptType={setApptType} />;
        }
        else {
          return <AppointmentFilterPage setApptType={setApptType} />;
        }
        break;
        //FB 8024 - End

      default:
        break;
    }
  }
  async function InsertLogs() {
    InsertPPLogs("Booking An Appointment", window.location.href, userName, "");
    //FB 8024 - Begin
    let adminSettingValue = (await GetAdminSettingValue("Enable PE Custom Appointments"))[0].toLowerCase();//FB 8214
    const data = (await GetAdminSettingValue("DisableTeleHealth_PE"))[0].toLowerCase();//FB 8192
    sessionStorage.setItem("CustomAppointments",adminSettingValue);
    setCustomApptValue(adminSettingValue);
    //FB 8192 - Begin
    if (data == "true" && adminSettingValue == "true"){
      setDisableForm(true);
      handleClick("inoffice");
    }
    //FB 8192 - End
    //FB 8024 - End
  }

  React.useEffect(() => {
    InsertLogs();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
      }}
    >
      <ListItem>
        <ListItemIcon>
          <IconButton onClick={() => navigate("/user/home/dashboard")}>
            <ArrowBack />
          </IconButton>
        </ListItemIcon>
      </ListItem>
      <Grid container spacing={2} style={{ display: disableForm ? "none" : "inline-block" }}>{/* FB 8192 */}
        <Grid item xs={12}>
          <Typography variant="h6">
            What type of appointment would you like to schedule?
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display: apptType === "telederm" ? "none" : "inline-flex",
          }}
        >
          {/* FB 7443 */}
          <Button
            onClick={() => handleClick("inoffice")}
            variant="outlined"
            className={
              apptType === "inoffice"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            In-office
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display: apptType === "inoffice" ? "none" : "inline-flex",
          }}
        >
          <Button
            onClick={() => handleClick("telederm")}
            variant="outlined"
            className={
              apptType === "telederm"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            {Configurations.digitalApptType}
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: apptType === "telederm" ? "flex" : "none",
            verticalAlign: "middle",
          }}
        >
          <Typography style={{ color: "red" }}>
            This is a video conferencing/Telephone appointment
          </Typography>
        </Grid>
      </Grid>
      <React.Fragment>{getcomponent()}</React.Fragment>
    </Box>
  );
}
